module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content relative"
  }, [_c('router-view')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b72ed2e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/tariffmerge/components/TariffMergeRouterView.vue
// module id = 2238
// module chunks = 1